/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this file will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/

(function() {
  // Add custom code below this line
  /**
   * This script automatically expands the level-1 and level-2 sub-menu items in the mobile navigation menu.
   * It first checks if the mobile menu is visible by looking for the 'nav--compress' class on the <nav> element with ID 'NavStandard'.
   * If the mobile menu is visible, it sequentially clicks the level-1 and then the level-2 sub-menu triggers to ensure they are expanded.
   * This code was added by Mor of Maple-Hosting on 07/19/2024.
   */

  document.addEventListener("DOMContentLoaded", function() {
    // Get the navigation element
    const navElement = document.getElementById('NavStandard');

    // Check if the mobile menu is visible
    if (!navElement || !navElement.classList.contains('nav--compress')) {
      return; // Exit if the mobile menu is not visible
    }

    // Selectors for level-1 and level-2 trigger buttons
    const level1Triggers = document.querySelectorAll('.mobile-menu__item--level-1 .mobile-nav__trigger');
    const level2Triggers = document.querySelectorAll('.mobile-menu__item--level-2 .mobile-nav__trigger');

    let currentTriggerIndex = 0;

    /**
     * Function to process the next level-1 trigger button.
     * This function will attempt to click the current level-1 trigger button and check if it expands.
     * If the button expands, it moves to the next button. If not, it retries up to 10 times.
     */
    function processNextLevel1Trigger() {
      if (currentTriggerIndex >= level1Triggers.length) {
        currentTriggerIndex = 0; // Reset index for level-2 processing
        processNextLevel2Trigger(); // Start processing level-2 triggers
        return;
      }

      const trigger = level1Triggers[currentTriggerIndex];
      let attempts = 0;

      /**
       * Function to attempt clicking the level-1 trigger button.
       * If the button expands (indicated by the 'is-expanded' class), it moves to the next button.
       * Otherwise, it retries up to 10 times with a delay of 100ms between attempts.
       */
      function tryClicking() {
        if (trigger.classList.contains('is-expanded')) {
          currentTriggerIndex++;
          processNextLevel1Trigger(); // Move to the next trigger
        } else if (attempts < 10) {
          // Simulate a real user click by creating and dispatching an event
          const event = new MouseEvent('click', {
            view: window,
            bubbles: true,
            cancelable: true
          });
          trigger.dispatchEvent(event);

          attempts++;
          setTimeout(tryClicking, 100); // Retry after 100ms
        } else {
          currentTriggerIndex++;
          processNextLevel1Trigger(); // Move to the next trigger even if this one failed
        }
      }

      tryClicking();
    }

    /**
     * Function to process the next level-2 trigger button.
     * This function will attempt to click the current level-2 trigger button and check if it expands.
     * If the button expands, it moves to the next button. If not, it retries up to 10 times.
     */
    function processNextLevel2Trigger() {
      if (currentTriggerIndex >= level2Triggers.length) {
        return; // All level-2 items processed
      }

      const trigger = level2Triggers[currentTriggerIndex];
      let attempts = 0;

      /**
       * Function to attempt clicking the level-2 trigger button.
       * If the button expands (indicated by the 'is-expanded' class), it moves to the next button.
       * Otherwise, it retries up to 10 times with a delay of 100ms between attempts.
       */
      function tryClicking() {
        if (trigger.classList.contains('is-expanded')) {
          currentTriggerIndex++;
          processNextLevel2Trigger(); // Move to the next trigger
        } else if (attempts < 10) {
          // Simulate a real user click by creating and dispatching an event
          const event = new MouseEvent('click', {
            view: window,
            bubbles: true,
            cancelable: true
          });
          trigger.dispatchEvent(event);

          attempts++;
          setTimeout(tryClicking, 100); // Retry after 100ms
        } else {
          currentTriggerIndex++;
          processNextLevel2Trigger(); // Move to the next trigger even if this one failed
        }
      }

      tryClicking();
    }

    // Start processing level-1 triggers
    processNextLevel1Trigger();
  });

  /**
   * This script replaces the schedule appointment button in the homepage with the Calendly integration button
   */
    document.addEventListener('DOMContentLoaded', function() {
    // Ensure the page is fully loaded before executing the script
    window.addEventListener('load', function() {
      // Check if the current page is the homepage
      if (window.location.pathname === '/') {
        // Locate the Schedule Appointment button using its class and aria-label
        var scheduleButton = document.querySelector('a.btn.btn--solid.btn--large.btn--black[aria-label="SCHEDULE APPOINTMENT"]');

        // If the button is found, replace it with the Calendly widget code
        if (scheduleButton) {
          // Create the Calendly widget button
          var calendlyWidget = document.createElement('div');
          calendlyWidget.innerHTML = `
            <div class="text__button aos-init aos-animate" data-aos="fade-up" data-aos-anchor="#Text--template--16210036719755__c3a7b20e-4347-407a-bfbb-74549b314a96" data-aos-delay="300">
              <a href="#" class="btn btn--solid btn--large btn--primary" onclick="Calendly.initPopupWidget({url: 'https://calendly.com/leviev?hide_gdpr_banner=1&primary_color=1a1a1a'}); return false;">Schedule Appointment</a>
            </div>
          `;

          // Replace the original button with the Calendly widget
          scheduleButton.parentElement.replaceChild(calendlyWidget.firstElementChild, scheduleButton);

          // Dynamically insert the Calendly CSS link into the document head
          var link = document.createElement('link');
          link.rel = 'stylesheet';
          link.href = 'https://assets.calendly.com/assets/external/widget.css';
          document.head.appendChild(link);

          // Dynamically insert the Calendly script into the document head
          var script = document.createElement('script');
          script.src = 'https://assets.calendly.com/assets/external/widget.js';
          script.type = 'text/javascript';
          script.async = true;

          // Ensure the Calendly popup initializes after the script is loaded
          script.onload = function() {
            // Reinitialize the Calendly widget
            // Calendly.initPopupWidget({url: 'https://calendly.com/leviev?hide_gdpr_banner=1&primary_color=1a1a1a'});
            console.log('Calendly script loaded.');
          };

          document.head.appendChild(script);
        }
      }
    });
  });


  document.addEventListener('click', function(e) {
    var closeBtn = e.target.closest('[data-popdown-close]');
    if (!closeBtn) return;
    var popdown = closeBtn.closest('search-popdown');
    if (!popdown) return;
    var input = popdown.querySelector('.search-form__input');
    if (input) input.value = '';
  });

  
  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
